module.exports = __webpack_public_path__ + "static/media/downloadc.4b258a5e.svg";